import React from "react";
import PropTypes from "prop-types";
import { snippetMeta, withFilters } from "./snippetReportSummaryUtils";
function SnippetReportSentence({
  selectedLocations,
  startDate,
  endDate,
  columns,
  total,
  selectedBedList,
}) {
  return (
    <div>
      {snippetMeta({ selectedLocations, startDate, endDate, selectedBedList })}
      &nbsp;<strong>{`total of ${total}`}</strong>&nbsp;
      {`${total === 1 ? "snippet" : "snippets"}${withFilters({ columns })}`}
    </div>
  );
}

SnippetReportSentence.propTypes = {
  facility: PropTypes.string,
  unit: PropTypes.string,
  filters: PropTypes.arrayOf(PropTypes.object),
  total: PropTypes.number,
  selectedBedList: PropTypes.object,
};

export default SnippetReportSentence;
